import { render, staticRenderFns } from "./PostulationsReport.vue?vue&type=template&id=59258456&scoped=true&"
import script from "./PostulationsReport.vue?vue&type=script&lang=js&"
export * from "./PostulationsReport.vue?vue&type=script&lang=js&"
import style0 from "./PostulationsReport.vue?vue&type=style&index=0&id=59258456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59258456",
  null
  
)

export default component.exports